module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wJGxIFOR7wz0gAAAFSSURBVDjLlZNRagIxEIa/xH3RgCb2XegVvIheQLyFirQioq7rLRYvUC/iQYQuYWVZWWTTh3b7UKPVPIX/nwwzX2YEwG6362VZ9ga8ACX3jwQ+lVLLwWCwF3Ec9/I8/3DO3XwhhPDqSql+kOf5u3OONE29gc45ms2m18uy7D0A2tZaJpPJzQo2mw3GGJ/VDoCyKv9wOFxFdLvdezzKAEBKeTdYCMFfRlVLAYDWmiiKSJKEKIoYjUYYY0jTFCklWmtOp5OXS1CJWmvK8vsHG40GRVEQhuG/XAKfOZ/Pf++z2YyqTeccl8uF1Wr163sTjMdjpJSEYchisbg7G94ErVYLYwzT6fRqkCqYnU7ndoKiKDgej6zX64cYyEqs1WrPMpABkACvVenb7RbnHNbaRxgkIo7j3vl89i6TtRafLoRAa41Sqi8AfjbyqXWu1+vL4XC4/wIId50GbS9kiQAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/float_16.png
 ** module id = 216
 ** module chunks = 0 1
 **/